/**
 * <product-specs> -- keeps the "Product Details" rows of blocks/product-specs.liquid in step
 * with the selected variant.
 *
 * The variant picker re-renders the section on every change and hands the new HTML to
 * listeners through the productSelect event. The rows are taken from that HTML rather
 * than rebuilt here, so Liquid stays the only place that decides what a row shows.
 * Only the rows are swapped; the <details> keeps whatever open state the shopper left.
 */

import { StandardEvents } from '@shopify/events';

class ProductSpecs extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
  }

  /** @param {Event & { promise?: Promise<{ detail?: { html?: Document } }> }} event */
  onProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        const fresh = detail?.html?.querySelector(`product-specs[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh) return;

        const panel = this.querySelector('[data-specs-panel]');
        const rows = this.querySelector('[data-specs-rows]');
        const freshPanel = fresh.querySelector('[data-specs-panel]');
        const freshRows = fresh.querySelector('[data-specs-rows]');
        if (!panel || !rows || !freshPanel || !freshRows) return;

        rows.innerHTML = freshRows.innerHTML;
        panel.hidden = freshPanel.hidden;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-specs] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-specs')) {
  customElements.define('product-specs', ProductSpecs);
}
